import styled from 'styled-components'
import { InfoIcon } from '@sainsburys-tech/bolt-icons'
import { RadioList } from '@sainsburys-tech/bolt'

const Container = styled.div`
  margin-top: 20px;
`

const ServiceRadioList = styled(RadioList)`
  margin-bottom: 5px;
`

const Link = styled.a`
  display: flex;
  line-height: 18px;
  color: ${props => props.theme.color.palette['brand-1']};
  text-decoration: underline;
  font-weight: ${props => props.theme.font.weight.bold};

  &:hover {
    color: ${props => props.theme.color.palette['brand-1-dark']};
  }
`

const Icon = styled(InfoIcon)`
  margin-right: 5px;
`

const Options = styled.span`
  display: flex;
  font-weight: ${props => props.theme.font.weight.bold};
`

const ServiceContainer = styled.div`
  margin-top: 10px;
  position: relative;
`

export { Container, ServiceRadioList, Link, Icon, Options, ServiceContainer }
